import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    listItems:{
        "& .css-10hburv-MuiTypography-root":{
            fontSize:'1rem'
        }
    }
})